export default __webpack_public_path__ + "static/11-6113b8f014aa2e404de895217fbbf0e4.webp";